import type { PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export type SurfaceProps = PropsWithChildren<{
  className?: string
}>

/** Frosted content panel, matching the Control Room column surface. Nesting one
 * inside another reads as a distinct raised panel. */
export const Surface = ({ className, children }: SurfaceProps) => (
  <div className={cn('rounded-md bg-white/38', className)}>{children}</div>
)
